document.addEventListener('DOMContentLoaded', function () {

    // Conferma invio email
    document.querySelectorAll('.confirm-email-form').forEach(function (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            const email = form.querySelector('input[name="email"]').value;
            const name  = form.querySelector('input[name="name"]').value;
            Swal.fire({
                title: 'Send confirmation email?',
                html: 'An email will be sent to:<br><strong>' + name + '</strong><br><small>' + email + '</small>',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Yes, send it',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#212529',
                cancelButtonColor: '#6c757d',
            }).then(function (result) {
                if (result.isConfirmed) {
                    form.submit();
                }
            });
        });
    });

    // Conferma eliminazione
    document.querySelectorAll('.confirm-delete-form').forEach(function (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            const name = form.querySelector('input[name="name"]').value;
            Swal.fire({
                title: 'Delete participant?',
                html: '<strong>' + name + '</strong> will be permanently deleted.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#dc3545',
                cancelButtonColor: '#6c757d',
            }).then(function (result) {
                if (result.isConfirmed) {
                    form.submit();
                }
            });
        });
    });

});